import './melgroupsages/style';
import FormStructure from './melgroupsages/form_structure';

export default FormStructure;